import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=190698ac&scoped=true&"
import script from "./Footer.vue?vue&type=script&setup=true&lang=js&"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190698ac",
  null
  
)

export default component.exports